import { render, staticRenderFns } from "./BuypassSettings.vue?vue&type=template&id=40aa4003"
import script from "./BuypassSettings.vue?vue&type=script&lang=js"
export * from "./BuypassSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports